import { render } from "./SiloPage.vue?vue&type=template&id=6948ef66&scoped=true"
import script from "./SiloPage.vue?vue&type=script&lang=js"
export * from "./SiloPage.vue?vue&type=script&lang=js"

import "./SiloPage.vue?vue&type=style&index=0&id=6948ef66&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6948ef66"]])

export default __exports__